export const verifyData = state => state.verifyData || {}

export const cell_id = state => {
  const { cell_id: cellId } = state.verifyData || {}
  return cellId || {}
}

export const orders = state => state.orders

export const roleId = state => state.roleId

export const unVerified = state => state.verifyData.unverified

export const env = state => state.env

export const ticket = state => state.ticket

export const getReason = state => state.verifyData.trinity_collect_reason

export const realnameVerifyStatus = state => state.verifyData.status

export const verifiedData = state => (state.verifyData && state.verifyData.verified) || {}

export const cell = state => state.cell || state.verifyData.phone || ''

export const appeal_fail_reason = state => state.verifyData.appeal_fail_reason

export const identityCards = state => (state.verifyData.unverified && state.verifyData.unverified.identity_cards) || []

export const docId = state => state.verifyData.doc_id

export const authState = (state) => state.authState

export const getNameInfo = (state) => state.nameInfo

export const getHasRealName = (state) => state.hasRealName
